import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';
import {translate, Datagrid, TextField, DateField} from 'react-admin';
import blue from '@material-ui/core/colors/blue';
import orange from '@material-ui/core/colors/orange';
import CardIcon from './CardIcon';
import keyBy from 'lodash/keyBy'
import ErrorIcon from "@material-ui/icons/ErrorOutline";

const rowStyle = (record, index, defaultStyle = {}) => {
    const time = new Date(record.time);
    const now = new Date().getTime();
    const moreThanDayOld = now - time.getTime() > 86400000;

    if (moreThanDayOld)
        return {
            ...defaultStyle,
            borderLeftColor: blue[500],
            borderLeftWidth: 14,
            borderLeftStyle: 'solid',
        };
    else if (!moreThanDayOld)
        return {
            ...defaultStyle,
            borderLeftColor: orange[500],
            borderLeftWidth: 14,
            borderLeftStyle: 'solid',
        };
    else
        return {
            ...defaultStyle,
        };
};

const styles = {
    main: {
        flex: '1',
        marginRight: '1em',
        marginTop: 20,
    },
    titleLink: { textDecoration: 'none', color: 'inherit' },
    card: {
        padding: '16px 0',
        overflow: 'inherit',
        textAlign: 'right',
    },
    title: {
        padding: '0 16px',
    },
    value: {
        padding: '0 16px',
        minHeight: 48,
        fontWeight: 'bold',
    },
    listItemText: {
        overflowY: 'hidden',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
    },
    comment: {
        maxWidth: '18em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    container: {
        overflowY: 'scroll',
        height: '500px',
        display: 'block',
    },
    fixedHeader: {
        position: 'sticky',
        top: 0,
        height: '42px',
        backgroundColor: 'white',
        borderBottom: '2px solid rgba(224, 224, 224, 1)',
    },
    devHeader: {
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'space-between'
    },
};

const location = {
    pathname: 'alerts',
};

const dateTimeOptions = {
    year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', hour12: false
};

const Alerts = ({
                    alerts = [],
                    nb,
                    translate,
                    classes,
                    selectedDevice,
                }) => (
        <div className={classes.main}>
            <CardIcon Icon={ErrorIcon} bgColor="#f44336" />
            <Card className={classes.card}>
                <div className={classes.devHeader}>
                    <div>
                        <Typography
                            variant="headline"
                            component="h2"
                            className={classes.value}
                        >
                            Alerts for {selectedDevice ? selectedDevice : 'all devices'}
                        </Typography>
                    </div>
                    <div>
                        <Typography className={classes.title} color="textSecondary">
                            Total
                        </Typography>
                        <Typography
                            variant="headline"
                            component="h2"
                            className={classes.value}
                        >
                            <Link to={location} className={classes.titleLink}>
                                {nb}
                            </Link>
                        </Typography>
                    </div>
                </div>
                <Divider/>
                <div className={classes.container}>
                    <Datagrid
                        data={keyBy(alerts, 'id')}
                        ids={alerts.map(({id}) => id)}
                        currentSort={{field: 'id', order: 'ASC'}}
                        basePath="/alerts" rowStyle={rowStyle}
                        classes={{headerRow: classes.fixedHeader}}
                    >
                        <TextField source="device"/>
                        <TextField source="info" cellClassName={classes.comment}/>
                        <DateField source="time" options={dateTimeOptions} showTime/>
                    </Datagrid>
                </div>
            </Card>
        </div>
);

const enhance = compose(
    withStyles(styles),
    translate
);

export default enhance(Alerts);
